import { render, staticRenderFns } from "./RbuItemFluctuations.vue?vue&type=template&id=6a6cd07a"
import script from "./RbuItemFluctuations.vue?vue&type=script&lang=js"
export * from "./RbuItemFluctuations.vue?vue&type=script&lang=js"
import style0 from "./RbuItemFluctuations.vue?vue&type=style&index=0&id=6a6cd07a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports